import * as Joi from 'joi';
import {
  getJoiObject,
  getMasterCodeObjectDropdownSchema,
  validateNRIC,
} from '../../../utils/JoiUtils';
import { IExamMasterCodeItem } from '../../../api/user/model';
import { IdTypeType } from '../../../models';
import { Dayjs } from 'dayjs';

export interface CandidateProfileRequestForAmendmentSchemaData {
  name?: string;
  IdType?: IdTypeType;
  NricFinPassportNo?: string;
  dateOfBirth?: Dayjs | undefined;
  prStatus?: IExamMasterCodeItem;
  citizenship?: IExamMasterCodeItem;
  remarks?: string;
}

const getNricFinOptionalJoiObject = (disableValidation = false): Joi.AnySchema =>
  getJoiObject(
    Joi.when('IdType', {
      is: 'P',
      then: Joi.string().alphanum().required().max(20).messages({
        'string.empty': `NRIC/FIN/Passport No. is not allowed to be empty.`,
        'any.required': `NRIC/FIN/Passport No. is not allowed to be empty.`,
        'string.alphanum': `Passport No. should be alphanumeric.`,
        'string.max': 'Passport No. is too long.',
      }),
      otherwise: Joi.when('IdType', {
        is: 'I',
        then: Joi.string()
          .alphanum()
          .required()
          .max(9)
          .custom((value, helpers) => validateNRIC(value, helpers), 'Validate NRIC/FIN/Passport No')
          .messages({
            'any.required': `NRIC/FIN/Passport No. is not allowed to be empty.`,
            'string.empty': `NRIC/FIN/Passport No. is not allowed to be empty.`,
            'string.alphanum': `NRIC / FIN should be alphanumeric.`,
            'string.max': 'NRIC / FIN is too long.',
            'string.pattern.nric': 'Invalid NRIC',
            'string.pattern.fin': 'Invalid FIN',
            'string.pattern.startCharError': 'Invalid NRIC / FIN',
            'string.pattern.nricYear':
              'Invalid NRIC format/NRIC format does not match with Year of Birth',
          }),
      }),
    })
  );

export const candidateProfileRequestForAmendmentSchema = Joi.object<CandidateProfileRequestForAmendmentSchemaData>(
  {
    name: Joi.string().allow('').max(66).messages({
      'string.max': 'Name is too long',
    }),
    IdType: Joi.string(),
    NricFinPassportNo: getNricFinOptionalJoiObject(false),
    dateOfBirth: Joi.string().allow(''),
    citizenship: getMasterCodeObjectDropdownSchema(true, 'Citizenship'),
    prStatus: getJoiObject(
      Joi.when('IdType', {
        is: 'I',
        then: getMasterCodeObjectDropdownSchema(false, 'PR status'),
      })
    ),
    remarks: Joi.string(),
  }
);
